const sitemap = (state = {}, action) => {
  if (action.error) {
    return state;
  }

  switch (action.type) {
    case 'LOAD_SITEMAP': {
      return action.payload;
    }

    default:
      return state;
  }
};

export default sitemap;
